import { Popover } from 'antd'
import { TRFPDocument } from '../RFPDetails/types'
import './style.scss'
import { Typography } from '../../../components/Typography'
import { Button, BUTTON_TYPES } from '../../../components/Button'
import { AttachmentsList } from '../../../components/AttachmentsList/AttachmentsList'
import { DOCUMENT_TYPE } from '../../../components/FileUpload/constants'
import { ReactComponent as CloseIcon } from 'assets/svg/Close24.svg'
import { useState } from 'react'

export const SubmittedDocumentsPopover = ({
  documents
}: {
  documents: TRFPDocument[]
}) => {
  const [open, setOpen] = useState(false)
  const attachments = documents.filter(
    (i) => i.document_type === DOCUMENT_TYPE.ATTACHMENTS
  )
  const handleOpenChange = (value: boolean) => {
    setOpen(value)
  }

  const closePopover = () => setOpen(false)

  if (!documents.length) return <div>-</div>
  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      visible={open}
      onVisibleChange={handleOpenChange}
      content={
        <div className="submitted-docs-popover column gap-24">
          <div className="submitted-docs-popover__header row space-between align-center">
            <Typography.Headline6>Submitted documents</Typography.Headline6>
            <Button
              small
              icon={<CloseIcon />}
              onClick={closePopover}
              type={BUTTON_TYPES.LINK}
            />
          </div>

          <div className="description-cell__files">
            <AttachmentsList
              label="Submitted files"
              files={documents.filter(
                (i) => i.document_type !== DOCUMENT_TYPE.ATTACHMENTS
              )}
              hideSeparator
              disableActions
            />
            {!!attachments.length && (
              <AttachmentsList
                label="Attachments"
                files={attachments}
                hideSeparator
                disableActions
              />
            )}
          </div>
        </div>
      }
    >
      <Button type={BUTTON_TYPES.LINK}> See documents</Button>
    </Popover>
  )
}
